<template>
<div class="col-12 text-left">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="p-2">
      <small class="text-muted">Report Supplies</small>
  </h3>
  <div class="p-2 dropdown-divider"></div>
  <div class="row">
    <div class="form-group col-3">
      <label for="subject">Start Date</label>
      <flat-pickr style="background-color:white;" class="form-control" v-model="reportSupplies.startDate" ></flat-pickr>
    </div>
    <div class="form-group col-3">
      <label for="subject">To Date</label>
      <flat-pickr style="background-color:white;" class="form-control" v-model="reportSupplies.toDate"></flat-pickr>
    </div>
    <div class="form-group col-3">
    <label for="uom">Supplies Name</label>
    <app-lookup-field :model="reportSupplies" :element="suppliesLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
  </div>
  </div>
  <br /><br />
  <button type="button" class="btn btn-outline-success" @click="print">Print <i class="far fa-save"></i></button>
  <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
  </div>
</div>
</template>

<script>
import api from '../../services/api'
import { reportSupplies } from '../../models/report'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        reportSupplies: {...reportSupplies},
        suppliesLookup: {
          id: 'supplies-list',
          title: 'Supplies List',
          type: 'form',
          apiUrl: 'supplies-list',
          filter: ['name'],
          fields: [
            {
              placeholder: 'Supplies Name',
              width: 12,
              column: 'suppliesName'
            }
          ],
          dtElements: [
            {
              title: 'Supplies Name',
              column: 'name'
            },
            {
              title: 'Remarks',
              column: 'remarks',
            },
          ],
          affectedField: [
            {
              from: 'id',
              to: 'suppliesId'
            },
            {
              from: 'name',
              to: 'suppliesName'
            },
          ]
        },
      }
    },
    async created() {

    },
    methods: {
    async print() {
      const rptApi = api('print/report-supplies')
      const query = { 
        params: {
          startDate: this.reportSupplies.startDate,
          toDate: this.reportSupplies.toDate,
          suppliesId: this.reportSupplies.suppliesId
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'Report-Supplies.xlsx')
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
      const currentESupplies = this.reportSupplies
      this.reportSupplies = {
          ...currentESupplies,
          ...data
      }
    },
    finishUpload(data) {
      const currentESupplies = this.reportSupplies
      this.reportSupplies = {
        ...currentESupplies,
        ...data
      }
    },
    }
}
</script>